module.exports = __webpack_public_path__ + "img/4_28.294b35d9.png";